module.exports = __webpack_public_path__ + "static/media/2_TSUTAYA - Hokkaido.f1ae0ac8.jpg";